import React from "react";
import { Icon } from "@campgladiator/cgui-core.atoms.icon";
import { Attachment } from "../..";
import styles from "./chat-video.module.scss";

const ChatVideo = ({ video }: { video: Attachment }) => (
  <a className={styles.videoLink} href={video.link} target="_blank">
    <div className={styles.videoWrapper}>
      <div className={styles.videoOverlay}>
        <Icon.Solid name="icon-play" />
      </div>
      <video className={styles.video} src={video.link} />
    </div>
  </a>
);

export default ChatVideo;
